import type { z } from 'zod';

import { EmployeePersonalInformation } from '../models/employee-personal-information';

export const EmployeePersonalInformationFormData = EmployeePersonalInformation.omit({ id: true });
export type EmployeePersonalInformationFormDataType = z.infer<typeof EmployeePersonalInformationFormData>;
